<template>
  <div v-if="recommendations.length > 0" class="flex align-items-center">
    <IconButton
      :disabled="isDisabled"
      @click="recommendationsStore.previousRecommendation"
      :aria-label="translate(`${LOCALE_PREFIX}.recommendations.previousRecAriaLabel`)"
    >
      <template #icon>
        <i class="material-symbols-rounded">keyboard_arrow_left</i>
      </template>
    </IconButton>

    <span class="nav-indicator text-xl text-bluegray-500">
      {{ currentRecommendationIndex + 1 }}/{{ recommendations.length }}
    </span>

    <IconButton
      :disabled="isDisabled"
      @click="recommendationsStore.nextRecommendation"
      :aria-label="translate(`${LOCALE_PREFIX}.recommendations.nextRecAriaLabel`)"
    >
      <template #icon>
        <i class="material-symbols-rounded">keyboard_arrow_right</i>
      </template>
    </IconButton>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRecommendationsStore } from '../../../../../stores/use-recommendations-store';
import { storeToRefs } from 'pinia';
import { useTranslation } from '@centric-os/helpers';
import { SitesLocalePrefix } from '../../../../../../enums';

const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_OVERVIEW.toString();

const recommendationsStore = useRecommendationsStore();
const { currentRecommendationIndex, recommendations } = storeToRefs(recommendationsStore);

const isDisabled = computed<boolean>(() => recommendations.value.length === 1);
</script>
<style scoped lang="scss">
:deep(.p-button:focus) {
  box-shadow: none !important;
  background: transparent !important;
}
</style>
